<script lang="ts">
    import Mushroom from "../world/mushroom.svelte";
</script>

<svg width="30" height="30" viewBox="0 0 50 50"><Mushroom /></svg>